// WordPress Theme: CUSTOM THEME

// Project CUSTOM JS

// Framework: jQuery 1.11.0

// Author: OLEX

// Copyright: 2016 olex.org

jQuery(document).ready(function($) {

	// ======================================== NAVIGATION

	// One Page Nav

	$('.header.fixed').onePageNav({

		currentClass: 'current',

		//		changeHash: false,

		scrollSpeed: 750,

		scrollThreshold: 0.15,

		//		filter: '',

		//		easing: 'swing',

		//		begin: function() {

		//			//I get fired when the animation is starting

		//		},

		//		end: function() {

		//			//I get fired when the animation is ending

		//		},

		//		scrollChange: function($currentListItem) {

		//			//I get fired when you enter a section and I pass the list item of the section

		//		}

	});





	// ======================================== SUPERFISH MENU

	// Superfish Responsive Helpers

	$( '<div class="mobnav-subarrow"></div>' ).insertBefore( '.sf-menu ul.sub-menu' );

	$('#mobnav-btn').click(

		function () {

			//$('.sf-menu').toggleClass("sf-mob-nav-active");

			$('.sf-menu').slideToggle(300);

			$(this).toggleClass('is-open');

			$('.nav-wrap .navigation').toggleClass('active');

	});



	// Hide open menu on anchor click

	if( jQuery(window).width() < 600) // Phones

	{

		$('.sf-menu li a, .home .logo a').click(

			function () {

				$('.sf-menu').slideToggle(300);

				$('#mobnav-btn').removeClass('is-open');

				$('.nav-wrap .navigation').removeClass('active');

			});

	}



	// Subnav Menu

	$('.mobnav-subarrow').click(

		function () {

			$(this).next('.sub-menu').slideToggle(300);

	});





	$('.mobnav-subarrow').on('touchstart', function () {

		$(this).toggleClass('xpopdrop')

	});





	// HOMEPAGE: Featured/Latest Stories

	$('.fade').slick({

		dots: true,

		infinite: true,

		speed: 350,

		fade: true,

		cssEase: 'ease',

		slidesToShow: 1,

		adaptiveHeight: true

	});







	// HOMEPAGE: Selected / Latest Stories (EasyTabs)

	$('#stories, #maps, #about').easytabs({
		updateHash: false
	});



//	$('#stories')

//		.bind('easytabs:after', function() {

//		$('.m_story .story-box').flexVerticalCenter();

//	});





	// ----------------- HOME MAPS LIST

	// Toggle/Slide DIV on button click

	$( ".subgroup > h4" ).click(function() {

		$(this).siblings( ".group-stories" ).slideToggle( 250 );

		$( this ).toggleClass("active");

	});



	// MOBILE: Toggle/Slide DIV on button click

	if( jQuery(window).width() < 600) // Phones

	{

		$( ".group-title" ).click(function() {

			$(this).siblings( ".subgroup-wrap" ).slideToggle( 250 );

			$( this ).toggleClass("active");

		});

	}





	// ----------------- HOME PROJECT

	// Toggle/Slide DIV on button click

	$( ".btn-slide" ).click(function() {

		$( ".content2" ).slideToggle( "slow" );



	});



	// Toggle Button Text on click

	$(".btn-slide").toggle(function() {

		$(this).text("Show less");

	}, function() {

		$(this).text("Show more");

	});



	$('.btn-slide').click(function(e) {

		$(this).attr('href',$(this).attr('href') == '#content2' ? '#content1' : '#content2');

	});





	// ----------------- HOME PRESS

	// Toggle/Slide DIV on button click

	$( ".btn-slide-translation" ).click(function() {

		$( ".content-translation" ).slideToggle( "slow" );

		$(this).toggleClass("active");

	});



	// Toggle Button Text on click

	$(".btn-slide-translation").toggle(function() {
		$(this).text("translation");

	}, function() {
		$(this).text("translation");

	});



	$('.btn-slide-translation').click(function(e) {

		$(this).attr('href',$(this).attr('href') == '#content2' ? '#content1' : '#content2');

	});





	// ======================================== MISC

	// Back to Top

	$('.back2top a').click(function () {

		$('body,html').animate({

			scrollTop: 0

		}, 600);

		return false;

	});



	// Scroll to Anchor (all Links in page)

	$(function() {

		$('a[href*="#"]:not([href="#"])').click(function() {

			if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {

				var target = $(this.hash);

				if (!target) { return false; }

				target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

				if (target.length) {

					$('html, body').animate({

						scrollTop: target.offset().top

					}, 600);

					return false;

				}

			}

		});

	});





	// ======================================== LIGHTBOXES, MODALS

	// ========= LIGHTGALLERY

	jQuery(".lightbox").lightGallery({



		selector: 'this',



		// Effects

		mode: 'lg-fade',

		cssEasing : 'cubic-bezier(0.25, 0, 0.25, 1)',



		// Utils

		speed: 600,

		closable: false, // can be closed by click anywhere

		loop: true, // Loop to beginning of gallery

		//keyPress: true, // Keyboard Nav



		// UI

		counter: false, // Image Counter

		controls: true, // Prev/Next Btns

		download: false, // Download button

		//getCaptionFromTitleOrAlt: true // Get captions



		// Addon: Fullscreen

		//fullScreen: true, // Enable Full Screen Mode



		// Addon: Zoom

		zoom: true, // Enable Zoom

		scale: 1 // Scale increments



	});

	var gap = window.layout_random_gap_range;


	$('.collection-slide-wrapper').css('height',$('.collection-slide-wrapper').height()-100);
	$('.collection-slide-wrapper').css('overflow-y','hidden');

	var $grid = $('.grid').masonry({
		// disable initial layout
		itemSelector: '.grid-item',
		initLayout: false,
		columnWidth: window.layout_columns_width,
		gutter: window.layout_gutter,
		columnsAreRows: 5,
		//...
	  });



	  var size = $('.grid > li').length / 3 * (window.collection_list_length_multiplier ? window.collection_list_length_multiplier : 300);
	  $('.collection-items-list').css('width',size-40);
	  // bind event
	  $grid.masonry( 'on', 'layoutComplete', function() {
		console.log('layout is complete');

		$('.grid li').each(function(){

			var min= -gap;
			var max= gap;
			var random = Math.random() * (+max - +min) + +min;
			$(this).css('margin-left',random);
			var min= -gap;
			var max= gap;
			var random = Math.random() * (+max - +min) + +min;
			$(this).css('margin-top',random);
			  });
	  });

	  $('.option').on('click',function(){
		//var cards = $(".collection-items-list li");





			//$grid.masonry('layout');
			//$grid.masonry();
			var parent = $(".collection-items-list");
			var divs = parent.children();
			while (divs.length) {
				parent.append(divs.splice(Math.floor(Math.random() * divs.length), 1)[0]);
			}
			$grid.masonry('destroy');
			var size = $('.grid > li').length / 3 * (window.collection_list_length_multiplier ? window.collection_list_length_multiplier : 300);
	  		$('.collection-items-list').css('width',size - 40);

			$grid = $('.grid').masonry({
				// disable initial layout
				initLayout: false,
				columnWidth: window.layout_columns_width,
				gutter: window.layout_gutter,
				columnsAreRows: 5,
				//...
			});

			$grid.masonry( 'on', 'layoutComplete', function() {


				$('.grid li').each(function(){

					var min= -gap;
					var max= gap;
					var random = Math.random() * (+max - +min) + +min;
					$(this).css('margin-left',random);
					var min= -gap;
					var max= gap;
					var random = Math.random() * (+max - +min) + +min;
					$(this).css('margin-top',random);
					  });
			  });

			$grid.masonry('layout');
			//$grid.masonry('layout');
			$(window).resize(function () {

				//var size = $('.grid > li').length / 3 * 300 - $(window).width()/3;
				//$('.collection-items-list').css('width',size);
				if($(window).width() > 768) {
					var isTouchDevice = 'ontouchstart' in document.documentElement;
					if(!isTouchDevice) {

						$grid.masonry('bindResize')
						$grid.masonry();
					}
				}
			});


	  })

	  $grid.masonry('layout');

	  	$(window).resize(function () {
		//var size = $('.grid > li').length / 3 * 300 - $(window).width()/3;
		//$('.collection-items-list').css('width',size);
		if($(window).width() > 768) {
			$grid.masonry('bindResize')
			$grid.masonry();
		}
	  });

	  jQuery('.gallery-content').each(function(){
		  var _this = jQuery(this);

		  $lg = jQuery(_this).lightGallery({

			selector: '.g-image',
			// Effects
			mode: 'lg-fade',
			galleryId: jQuery(_this).data('galleryid'),
			addClass: jQuery(_this).data('galleryid'),
			cssEasing : 'cubic-bezier(0.25, 0, 0.25, 1)',
			// Utils
			hideControlOnEnd: false,
			iframeMaxWidth: '100%',
			videoMaxWidth: '1200px',
			speed: 600,

			closable: false, // can be closed by click anywhere

			loop: false, // Loop to beginning of gallery

			//keyPress: true, // Keyboard Nav

			//enableSwipe: false,


			pager: true,
			// UI

			counter: jQuery(_this).find('.g-image').length > 1, // Image Counter
			controls: true, // Prev/Next Btns

			//download: true // Download button

			getCaptionFromTitleOrAlt: false, // Get captions

			//data-sub-html: '',
			// Addon: Fullscreen

			//fullScreen: true, // Enable Full Screen Mode



			// Addon: Zoom

			// Addon: Zoom

			zoom: true, // Enable Zoom

			scale: 1, // Scale increments
		});



	  })



	var current_scrollPos = 0;

	if($(".collection-slide-wrapper").scrollLeft() <= 0) {
		$('.collection-nav').find('.prev').addClass('invisible');
	} else {
		$('.collection-nav').find('.prev').removeClass('invisible');
	}


	$('.collection-nav').find('.next').on('click', function(){
		current_scrollPos = $(".collection-slide-wrapper").scrollLeft();
		$(".collection-slide-wrapper").animate({
			scrollLeft: '+=' + $(".collection-slide-wrapper").width()
		},{
			duration: 80,
			complete: function(){
				if(($(".collection-slide-wrapper").scrollLeft() + $(window).width() ) >= $(".collection-items-list").outerWidth() - $(window).width() ) {
					$('.collection-nav').find('.next').addClass('invisible');
				} else {
					$('.collection-nav').find('.next').removeClass('invisible');
				}
			}
		});



		//$('.collection-slide-wrapper').scrollLeft($('.collection-slide-wrapper').scrollLeft() + $(window).width()/3);
	});





	$(".collection-slide-wrapper").on('scroll',function(){


		if($(".collection-slide-wrapper").scrollLeft() <= 0) {
			$('.collection-nav').find('.prev').addClass('invisible');
		} else {
			$('.collection-nav').find('.prev').removeClass('invisible');
		}






	})

	$('.collection-nav').find('.prev').on('click', function(){

		$(".collection-slide-wrapper").animate({
			scrollLeft: '-=' + $(".collection-slide-wrapper").width()
		},{
			duration: 80,
			complete: function(){

					$('.collection-nav').find('.next').removeClass('invisible');

			}
		});

		//$('.collection-slide-wrapper').scrollLeft($('.collection-slide-wrapper').scrollLeft() - $(window).width()/3);
	});


	// ========= LIGHTGALLERY - LOT IMG GALLERY
	jQuery( '.pagename-voyagers').find('.story-image').on('click',function(e){

		e.preventDefault();



		jQuery(this).find('.gallery-content').find('.g-image').first().trigger('click');

	});

	jQuery( '.grid').find('li').on('click',function(e){

		e.preventDefault();



		jQuery(this).find('.gallery-content').find('.g-image').first().trigger('click');

	});


	jQuery(".single-stories, .single, .mpf-p-popup-holder").lightGallery({



		selector: 'a.story-image',



		// Effects

		mode: 'lg-fade',

		cssEasing : 'cubic-bezier(0.25, 0, 0.25, 1)',



		// Utils

		speed: 600,

		closable: false, // can be closed by click anywhere

		loop: true, // Loop to beginning of gallery

		//keyPress: true, // Keyboard Nav

		//enableSwipe: false,



		// UI

		counter: false, // Image Counter

		controls: true, // Prev/Next Btns

		//download: true // Download button

		getCaptionFromTitleOrAlt: true, // Get captions

		//data-sub-html: '',



		// Addon: Fullscreen

		//fullScreen: true, // Enable Full Screen Mode



		// Addon: Zoom

		zoom: true, // Enable Zoom

		scale: 1 // Scale increments



	});



	// ========= LIGHTGALLERY: Eliminate Lightbox on mobile devices

	if ( $(window).width() < 599) { // if is Mobile

		$( "a.image-link picture" ).unwrap();

	}





	// ======================================== MISC

	// Add Classes to IMG inside A

	$( "a" ).has( "img" ).addClass( "has-img" );



	//Add first/last classes to LIs

	$('ul').each(function(){

		$('li:first-child', this).addClass('first');

		$('li:last-child', this).addClass('last');

	});



	// Find Empty Tags

	$('p,em,b,strong,span').each(function() {

		if ($.trim ($(this).text()) === ""){

			$(this).addClass('empty-tag');

		}

	});







	// ======================================== PROJECT SINGLE

	$('.pagename-quest .cb-section .story-box').flexVerticalCenter();





}); // end jQuery Document
